import { LoadingOutlined, ScheduleOutlined } from '@ant-design/icons';
import { Spin, theme } from 'antd';
import { SectionCard } from '../../Common/Layout';
import React, { useState } from 'react'
import HolidaysService from '../../Services/HolidaysService';
import dayjs, { Dayjs } from 'dayjs';
import { Link } from 'react-router-dom';
import { EmptyIcon } from '../../Common/FullPageSpinner';
import { DBRecordStatus } from '../../Common/CommonComponent';

interface IProps {
    fromDate: string,
    toDate: string
}

interface HolidayRes {
    date: Dayjs | string,
    id: string,
    name: string,
    sno: number
}

const HolidayCard = ({ fromDate, toDate }: IProps) => {
    const { token } = theme.useToken();
    const [holidayData, setHolidayData] = useState<HolidayRes[]>([])
    const [totalHoliday, setTotalHoliday] = useState(0);
    const [loading, setLoading] = useState(false);

    const getHolidayDetails = async () => {
        try {
            setLoading(true);
            const res = await HolidaysService.getUpdatesList(0, 5, "", DBRecordStatus.Active, fromDate, toDate, "Date", "descend")
            if (res?.result && res?.status) {
                setHolidayData(res?.result?.items)
                setTotalHoliday(res?.result?.totalRecords || 0)
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setLoading(false);
        }
    }

    React.useEffect(() => {
        getHolidayDetails();
    }, [fromDate, toDate])

    return (
        <>
        

            <SectionCard
                title={
                    <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        Holidays
                        <span style={{ background: "linear-gradient(130deg, #6c8ef5, #3F5BD3)", height: 18, minWidth: 18, padding: "0 6px", color: "#fff", fontSize: 11, fontWeight: 700, borderRadius: 9, display: "inline-flex", alignItems: "center", justifyContent: "center" }}>
                            {totalHoliday}
                        </span>
                    </span>
                }
                style={{
                    width: "100%",
                    maxHeight: 538,
                    display: "flex",
                    flexDirection: "column"
                }}
                extra={
                    <Link style={{ color: "#3F5BD3", fontSize: 12, fontWeight: 600 }} to="/holidays" target="_blank">
                        View All
                    </Link>
                }
                noPadding
            >
                <div style={{ padding: "12px 16px 14px 16px", overflowY: "auto", flex: 1 }}>
                    <Spin
                        spinning={loading}
                        indicator={<LoadingOutlined style={{ fontSize: 30, color: "#3F5BD3" }} spin />}
                    >
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                            {holidayData.map((holiday) => (
                                <div key={holiday?.id}  style={{display:'flex', alignItems: 'center', justifyContent: 'space-between',padding: "12px 14px", borderRadius: 10, border: `1px solid ${token.colorBorderSecondary}`, transition: "background 0.15s ease, border-color 0.15s ease, transform 0.15s ease", background: token.colorFillAlter}}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                        <div  style={{ width: 36, height: 36, background: token.colorPrimaryBg, display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "50%" }}>
                                            <ScheduleOutlined style={{ fontSize: 17, color: token.colorPrimary }} />
                                        </div>
                                        <div style={{ fontSize: 13, fontWeight: 600, color: token.colorText }}>
                                            {holiday.name}
                                        </div>
                                    </div>
                                    <div style={{ fontSize: 13, color: token.colorPrimary, fontWeight: 700, fontVariantNumeric: "tabular-nums" }}>
                                        {dayjs(holiday?.date).format("DD/MM/YYYY")}
                                    </div>
                                </div>
                            ))}
                            {holidayData.length === 0 && (
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 20, gap: 8 }}>
                                    <EmptyIcon />
                                </div>
                            )}
                        </div>
                    </Spin>
                </div>
            </SectionCard>
        </>
    )
}

export default HolidayCard